import * as z from 'zod';

import { ipSchema, selectInputStringSchema } from '@/_schemas/generic';

import { infrastructureQuerySchema } from './infrastructure-query-schema';

export const infrastructureFormSchema = infrastructureQuerySchema
  .omit({ name: true, location: true, ip: true, notes: true })
  .extend({
    name: z.string().min(3),
    location: selectInputStringSchema(false),
    ip: ipSchema('v4', false),
    notes: z.string(),
  });
export type InfrastructureFormSchema = z.infer<typeof infrastructureFormSchema>;
